interface IProps {
  data: object | object[];
}

const LdJsonScript = ({ data }: IProps) => (
  <script
    type="application/ld+json"
    dangerouslySetInnerHTML={{
      __html: JSON.stringify(data)
        .replace(/</g, '\\u003c')
        .replace(/>/g, '\\u003e')
        .replace(/&/g, '\\u0026'),
    }}
  />
);

export default LdJsonScript;
